/**
 Capture the form submit and show response in modal
 */

(($ => {

    // jQuery ready event
    $(document).ready(()=> {
        //alertify.parent($('.mail-box .holder').get(0));

        alertify.logPosition('bottom left').maxLogItems(4).closeLogOnClick(true);
        $('.subscribtion-box input:checkbox:enabled').on('change', function(){
            var data = {
                'action': 'apsis/subscriptions',
                'subscriptions': {}
            };
            var $checkbox = $(this), initial_value = !$checkbox.val();
            data['subscriptions'][$checkbox.val()] = 0 + $checkbox.is(':checked');
            $.ajax({
                url: apsis.ajax_url,
                type: 'post',
                dataType: "json",
                "data": data,
                success: function success(response) {
                    alertify.clearLogs();
                    if(response && response.Code && (response.Code > 0)){
                        alertify.success(response.Message);
                    }
                    else {
                        //$checkbox.get(0).checked = initial_value;
                        alertify.delay(0).error((response)?((response.Code)?response.Message:response):'Unspecified error');
                    }
                }
            });
        });
        $("form[data-email-subscribe-ajax]").validate({
            focusCleanup: true,
            //onfocusout:false,
            onkeyup:false,
            onlick: false,
            showErrors: function(errorMap, errorList) {
                alertify.clearLogs();
                $.each(errorMap, function(field, message){
                    alertify.error(message)
                });
            },
            rules: {
                pf_Email: {
                    required: true,
                    email: true
                },
                pf_Demographicfield2: 'required',
                pf_Demographicfield5: 'required',
                pf_SubscriberName: 'required'
            },
            messages: {
                pf_Demographicfield2: 'Vänligen fyll i företagsnamn',
                pf_Demographicfield5: 'Vänligen fyll i din titel',
                pf_SubscriberName: 'Vänligen fyll i ditt namn',
                pf_Email: 'E-postadressen är inte giltig. Vänligen försök igen.'
            },
            invalidHandler: function invalidHandler(event, validator) {},
            submitHandler: function submitHandler(form) {
                var data = {};
                $.each($(form).serializeArray(), function (i, row) {
                    data[row.name] = row.value;
                });
                $.ajax({
                    url: apsis.ajax_url,
                    type: 'post',
                    dataType: "json",
                    "data": data,
                    success: function success(response) {
                        alertify.clearLogs();
                        if(response && response.Code && (response.Code > 0)){
                            alertify.success(response.Message);
                            $('#submit-email-subscription').prop( "disabled", true );
                        }
                        else {

                            alertify.delay(0).error((response)?((response.Code)?response.Message:response):'Unspecified error');
                        }
                    }
                });
            }
        });

    });


}))(jQuery);